import React, {useState, Dispatch, SetStateAction} from 'react'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import {useAuth, VectorUserModel} from '../../../../../modules/auth'
import {profileApi} from '../../../../../../_metronic/helpers/custom/api/profileApi'
import {CardFooter} from '../../../../../modules/custom/form-elements/CardFooter'
import {handleFileUpload} from '../../../../../../_metronic/helpers/custom/funcs/handleFileUpload'
import {TermsOfServiceModal} from './TermsOfServiceModal'
import {ISetFieldValue} from '../../../../../../_metronic/helpers/custom/tsHelpers/generalHelpers'
import {FormattedMessage, useIntl} from 'react-intl'
import {FileInput} from '../../../../../modules/custom/form-elements/file-inputs/FileInput'
import {crauzerProfileApi} from '../../../_requests'
import {ICrauzerUser} from '../../../../../../_metronic/helpers/custom/tsHelpers/crauzerUser'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'

interface Props {
  user: VectorUserModel
}

export function PassportTempTab({user}: Props) {
  const intl = useIntl()
  const {updateUserData} = useAuth()

  const initialValues: Partial<VectorUserModel> = {
    passport: user?.passport || {base_url: '', filename: ''},
    passport_number: user?.passport_number || '',
    passport_date: user?.passport_date || '',
  }

  const [loading, setLoading] = useState(false)
  const [imageIsLoading, setImageIsLoading] = useState(false)

  const [success, setSuccess] = useState(false)

  const saveImage = async (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: ISetFieldValue
  ) => {
    setLoading(true)
    setImageIsLoading(true)

    await handleFileUpload(e, setFieldValue, 'passport', 'file', profileApi.addPassportScan, true)

    setImageIsLoading(false)
    setLoading(false)
  }

  const deleteImage = async (setFieldValue: ISetFieldValue) => {
    setFieldValue('passport', '')
  }

  const handleSubmit = async (values: Partial<VectorUserModel>) => {
    console.log('values', values)
    try {
      setLoading(true)
      const response = await profileApi.editProfileOverview({
        passport: values?.passport?.filename || null,
        passport_number: values?.passport_number || null,
        passport_date: values?.passport_date || null,
      })
      console.log('resp', response)

      if (response) {
        updateUserData(response)
        setLoading(false)

        setSuccess(true)

        setTimeout(() => {
          setSuccess(false)
        }, 3000)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <Formik
          //   validationSchema={profileOverviewSchema(intl)}
          initialValues={initialValues}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({values, errors, setFieldValue}) => (
            <Form noValidate className='form'>
              {/* {JSON.stringify(errors)} */}

              <div className='card-body border-top p-9'>
                <div className='mb-5'>
                  <FileInput
                    title={intl.formatMessage({id: 'PROFILE.PAGE.OVERVIEW.FIRST_PASSPORT_PAGE'})}
                    inputName='passport'
                    inputId={`${user.id}-profile-file-input`}
                    uploadedFile={{
                      base: values?.passport?.base_url || '',
                      link: values?.passport?.filename || '',
                    }}
                    setFieldValue={setFieldValue}
                    uploadFunction={saveImage}
                    deleteFunction={deleteImage}
                    placeholder={intl.formatMessage({
                      id: 'PROFILE.PAGE.OVERVIEW.FIRST_PASSPORT_PAGE',
                    })}
                    notification={{
                      bool: true,
                      text: intl.formatMessage({
                        id: 'PROFILE.PAGE.OVERVIEW.FIRST_PASSPORT_PAGE.PROMPT',
                      }),
                      borderTop: false,
                    }}
                    required={false}
                    loading={imageIsLoading}
                    linkEndpoint='/passport'
                  />
                </div>

                <div className='row mb-5'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <FormattedMessage id='PROFILE.PAGE.PASSPORT.NUMBER' defaultMessage='Number' />
                  </label>
                  <div className='col-lg-8 w-50'>
                    <div className='row'>
                      <Field
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        name='passport_number'
                        placeholder=''
                      />
                      <div className='text-danger'>
                        <ErrorMessage name='passport_number' />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mb-5'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <FormattedMessage id='PROFILE.PAGE.PASSPORT.DATE_TO' defaultMessage='Expiration Date' />
                  </label>
                  <div className='col-lg-8 w-50'>
                    <div className='row'>
                      <Field
                        type='date'
                        className='form-control form-control-lg form-control-solid'
                        name='passport_date'
                        placeholder=''
                      />
                      <div className='text-danger'>
                        <ErrorMessage name='passport_date' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CardFooter loading={loading} success={success} />
            </Form>
          )}
        </Formik>
      </div>
    </>
  )
}
